import React, { useState, useEffect } from 'react';
import { getCurrentWIB } from '../../utils/dateUtils';

const CountdownTimer = ({ targetDate, dominantColor = '#3b82f6' }) => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    const updateCountdown = () => {
      const now = getCurrentWIB().getTime();
      const distance = targetDate - now;

      if (distance < 0) {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      setTimeLeft({ days, hours, minutes, seconds });
    };

    updateCountdown();
    const timer = setInterval(updateCountdown, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  const formatNumber = (num) => {
    return num.toString().padStart(2, '0');
  };

  const timeUnits = [
    {
      value: timeLeft.days,
      label: 'Days',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
      ),
      gradient: 'from-orange-500 to-pink-500'
    },
    {
      value: timeLeft.hours,
      label: 'Hours',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
      gradient: 'from-pink-500 to-purple-500'
    },
    {
      value: timeLeft.minutes,
      label: 'Minutes',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
      gradient: 'from-purple-500 to-blue-500'
    },
    {
      value: timeLeft.seconds,
      label: 'Seconds',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      ),
      gradient: 'from-blue-500 to-indigo-500'
    }
  ];

  return (
    <div className="flex justify-center gap-4 md:gap-6 mb-4 flex-wrap">
      {timeUnits.map((unit, index) => (
        <div key={unit.label} className="flex flex-col items-center">
          <div className={`w-20 md:w-28 h-20 md:h-28 bg-gradient-to-br ${unit.gradient} rounded-lg shadow-lg flex flex-col items-center justify-center transform hover:scale-105 transition-all duration-200 border border-white/20 relative`}>
            <div className="absolute top-2 right-2 text-white/40">
              {unit.icon}
            </div>

            <div className="text-2xl md:text-3xl font-bold text-white mb-1 relative z-10">
              {formatNumber(unit.value)}
            </div>
            <div className="text-xs md:text-sm text-white/90 font-medium uppercase tracking-wide relative z-10">
              {unit.label}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CountdownTimer;